var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetrictypeAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69727 22.2617C6.69727 21.9618 6.94034 21.7188 7.24019 21.7188H13.5743C13.8742 21.7188 14.1172 21.9618 14.1172 22.2617V34.025C14.1172 34.3249 13.8742 34.5679 13.5743 34.5679H7.24019C6.94034 34.5679 6.69727 34.3249 6.69727 34.025V22.2617ZM7.78311 22.8046V33.4821H13.0314V22.8046H7.78311Z",
    fill: "url(#paint0_linear_5299_1813)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7451 12.7607C15.7451 12.4608 15.9882 12.2178 16.288 12.2178H22.6221C22.922 12.2178 23.1651 12.4608 23.1651 12.7607V34.0252C23.1651 34.3251 22.922 34.5681 22.6221 34.5681H16.288C15.9882 34.5681 15.7451 34.3251 15.7451 34.0252V12.7607ZM16.831 13.3036V33.4823H22.0792V13.3036H16.831Z",
    fill: "url(#paint1_linear_5299_1813)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7939 5.06929C24.7939 4.76944 25.037 4.52637 25.3369 4.52637H31.671C31.9708 4.52637 32.2139 4.76944 32.2139 5.06929V34.0252C32.2139 34.3251 31.9708 34.5681 31.671 34.5681H25.3369C25.037 34.5681 24.7939 34.3251 24.7939 34.0252V5.06929ZM25.8798 5.61221V33.4823H31.1281V5.61221H25.8798Z",
    fill: "url(#paint2_linear_5299_1813)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4763 34.0244C34.4763 33.7245 34.2333 33.4814 33.9334 33.4814H4.97749C4.67765 33.4814 4.43457 33.7245 4.43457 34.0244C4.43457 34.3242 4.67765 34.5673 4.97749 34.5673H33.9334C34.2333 34.5673 34.4763 34.3242 34.4763 34.0244Z",
    fill: "url(#paint3_linear_5299_1813)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5299_1813",
    x1: 14.2625,
    y1: 11.1977,
    x2: 28.37,
    y2: 27.2577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA5EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BE1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5299_1813",
    x1: 14.2616,
    y1: 11.1979,
    x2: 28.3691,
    y2: 27.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA5EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BE1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5299_1813",
    x1: 14.2617,
    y1: 11.1979,
    x2: 28.3692,
    y2: 27.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA5EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BE1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5299_1813",
    x1: 14.2619,
    y1: 11.1971,
    x2: 28.3694,
    y2: 27.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA5EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BE1EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetrictypeAnchor);
export default __webpack_public_path__ + "static/media/metrictype_anchor.9090766fd2dd5e71dbd423320c135063.svg";
export { ForwardRef as ReactComponent };